export default __webpack_public_path__ + "static/media/BUSD.a51e69fb.png";